import { Injectable, signal } from '@angular/core';

/**
 * Open/closed state of the quick-access palette.
 *
 * Kept in a root service rather than on the component so anything in the shell
 * can raise it — the top-bar search button does, and the component itself owns
 * the `Ctrl`/`⌘` + `K` shortcut.
 */
@Injectable({ providedIn: 'root' })
export class CommandPaletteService {
  private readonly _isOpen = signal(false);

  /** Whether the palette is currently showing. */
  readonly isOpen = this._isOpen.asReadonly();

  open(): void {
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
  }

  toggle(): void {
    this._isOpen.update((open) => !open);
  }
}
